<template>
    <article class="bg-base prose max-w-none rounded-lg border p-10" v-html="page.body">
    </article>
  </template>
  
  <script>
  export default{
    props: ['options'],
    data(){
      return{
        page: {}
      }
    },
    mounted(){
      this.getPage()
    },
    methods: {
      getPage(){
        this.$axios.get('/pages/' + this.options.slug,).then((response)=>{
          this.page = response.data
        })
      }
    }
  }
  </script>